import { AccordionHeader, AccordionItem, AccordionPanel, Button } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import INavigationArea from "../../../models/navigation/INavigationArea";
import INavigationSection from "../../../models/navigation/INavigationSection";
import MobileSection from "./MobileSection";
import { useMobileStyles } from "./MobileStyles";

interface IMobileArea {
    index: number;
    area: INavigationArea;
    onNavigate: () => void;
}

export default function MobileArea(props: IMobileArea) {
    const { area } = props;

    const { t } = useTranslation("navigation");
    const styles = useMobileStyles();

    return (
        <AccordionItem value={props.index}>
            <AccordionHeader as="div" expandIconPosition="end" className={styles.accordionHeader}>
                <Button appearance="subtle" className={styles.button}>
                    {area.name}
                </Button>
            </AccordionHeader>
            <AccordionPanel>
                {
                    area.sections
                        .sort((a, b) => a.order - b.order)
                        .map((nav: INavigationSection, index: number) => (
                            <MobileSection key={index} section={nav} area={area} onNavigate={props.onNavigate} />
                        ))
                }
            </AccordionPanel>
        </AccordionItem>
    );
}